import * as React from "react";
import * as main from "../../../styles/main.module.scss";
import * as screen2 from "./screen2.module.scss";

export const ProblemsWithVideo = ({ targetGroup, targetTextCustom }) => {
  return (
    <section className={screen2.screen2}>
      <div className="container">
        <h2 className={main.title2}>Если у вашего ребёнка...</h2>
        <div className={screen2.screen2__list}>
          <div className={screen2.screen2__listItem}>
            <p className={screen2.screen2__listText}>проблемы с успеваемостью в школе;</p>
          </div>
          <div className={screen2.screen2__listItem}>
            <p className={screen2.screen2__listText}>отсутствует мотивация к учёбе;</p>
          </div>
          <div className={screen2.screen2__listItem}>
            <p className={screen2.screen2__listText}>сложности с чтением, запоминанием прочитанного и пройденного материала;</p>
          </div>
          <div className={screen2.screen2__listItem}>
            <p className={screen2.screen2__listText}>проблемы с самостоятельным выполнением домашних заданий;</p>
          </div>
        </div>
        <div className={screen2.screen2__text}>… мы настоятельно рекомендуем <span className={screen2.screen2__textOrange}>не откладывать и начать решать эти проблемы</span> вместе
          с нами на курсе
          {
            targetGroup === "teens" && !targetTextCustom ?
              " «Учись\u00A0учиться 8–11\u00A0класс»."
              :
              targetGroup === "kids" && !targetTextCustom ?
                " «Учись\u00A0учиться 5–7\u00A0класс»."
                :
                !targetTextCustom ?
                " «Учись\u00A0учиться»."
                  :
                  targetTextCustom
          }

        </div>
        <div className={screen2.video__content} style={{display: targetGroup ? "block" : "none"}}>
          <div className={screen2.video__screencastWrapper}>
            {
              targetGroup === "kids" ?
                (
                  <iframe
                    className={screen2.video__content_iframe}
                    src={"https://65395.servicecdn.ru/videos/65395_sPdcGwVnmfWjF8FK"}
                    title={"Видео Учись учиться 5-7"}
                    allow={"autoplay; encrypted-media"}
                    allowFullScreen
                  />
                )
                :
                (
                  <iframe
                    className={screen2.video__content_iframe}
                    src="https://www.youtube.com/embed/EGrw3oQ2vXg"
                    title={"Видео Учись учиться 8-11"}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen/>
                )
            }
          </div>
          <p className={screen2.video__text}>2-минутное видеознакомство с&nbsp;курсом «Учись Учиться» </p>
        </div>
      </div>
    </section>
  );
};
